const steps = [
  {
    icon: 'ri-book-2-line',
    step: '01',
    title: '挑选作品',
    desc: '在178漫画网一起看漫画专区，挑一部你和漫友都感兴趣的热门漫画，看看人气和评分。',
  },
  {
    icon: 'ri-user-add-line',
    step: '02',
    title: '创建/加入同看房间',
    desc: '一键创建同看房间，把房间链接发给漫友，大家聚集在一起，等待开更。',
  },
  {
    icon: 'ri-tv-2-line',
    step: '03',
    title: '一起同步看 & 聊',
    desc: '新一话实时同步上线，翻页进度全员一致，边看边聊剧情，追更从此不孤单。',
  },
];

export default function HowItWorks() {
  return (
    <section className="relative py-16 md:py-24">
      <div className="container-site">
        <div className="reveal mx-auto max-w-2xl text-center">
          <span className="text-xs font-medium uppercase tracking-[0.3em] text-primary-400">
            一起看怎么玩
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            三步，把追漫画变成集体狂欢
          </h2>
        </div>

        <div className="relative mt-14 grid gap-6 md:grid-cols-3">
          <div className="absolute left-[16%] right-[16%] top-10 hidden border-t-2 border-dashed border-background-300/50 md:block"></div>
          {steps.map((s, idx) => (
            <div
              key={s.step}
              className={`reveal relative rounded-2xl border border-background-200/70 bg-background-100/50 p-7 text-center transition-all hover:border-accent-400/50`}
              style={{ transitionDelay: `${idx * 110}ms` }}
            >
              <div className="relative mx-auto flex h-20 w-20 items-center justify-center rounded-full border border-background-200 bg-background-50 text-2xl text-primary-400">
                <span className="animate-pulse-ring rounded-full"></span>
                <i className={`${s.icon}`}></i>
              </div>
              <span className="mt-5 inline-block font-heading text-sm tracking-widest text-accent-400">
                STEP {s.step}
              </span>
              <h3 className="mt-1 font-heading text-2xl text-foreground-950">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}